import { useState } from "react";
import "./ProductStoreShop.scss";
import { AreaFormPage } from "./AreaFormPage/AreaFormPage";
import { ShopsMapPage } from "./ShopsMapPage/ShopsMapPage";

export const ProductStoreShop = ({ onBackClick, onExitClick }) => {
  const [step, setStep] = useState(0);
  const [address, setAddress] = useState({
    country: "South Africa",
    postal: "",
    flag: "https://flagcdn.com/w320/za.png",
  });
  const [userLocation, setUserLocation] = useState({
    lat: -30.559482,
    lng: 22.937506,
    zoom: 10,
  });
  const [nearestStores, setNearestStores] = useState([]);

  if (step === 1)
    return (
      <ShopsMapPage
        userLocation={userLocation}
        nearestShops={nearestStores}
        onBackClick={() => setStep(0)}
        onExitClick={onExitClick}
      />
    );

  return (
    <AreaFormPage
      onBackClick={onBackClick}
      address={address}
      updateAddress={setAddress}
      updateUserLocation={(newLocation) => setUserLocation(newLocation)}
      updateNearestStores={(nearestStores) => setNearestStores(nearestStores)}
      onContinue={() => setStep(1)}
    />
  );
};
